import { colors } from 'constants/colorsBase';
import styled from 'styled-components';

export const HistoryHeaderWrapper = styled.div`
  font-size: 1.5rem;
  display: flex;
  padding-bottom: 0.2rem;
  width: 80.5rem;
  margin-left: 11.063rem;
  border-bottom: 1px solid ${colors.lineColor};
`;
export const DayHistoryHeader = styled.div`
  width: 18.75rem;
  text-align: center;
`;
export const AmountHistoryHeader = styled.div`
  width: 15.625rem;
  text-align: center;
`;
